import { Link } from 'react-router-dom'
import { useCurrentUser } from '@/api/hooks'

export function SeriesModelLink({
  identity,
}: {
  identity: {
    catalogClassId: string | null
    catalogSubtypeId?: string | null
    divisionCode?: string | null
    catalogClass?: { name: string } | null
    catalogSubtype?: { name: string } | null
  }
}) {
  const user = useCurrentUser()
  const canBrowseCatalog =
    user.data?.isAdmin ||
    user.data?.showRoles?.some(assignment =>
      ['admin', 'organizer', 'lead_secretary', 'secretary'].includes(assignment.role)
    )
  if (!identity.catalogClassId)
    return (
      <span className="block text-xs font-normal">
        Legacy identity · model reconciliation required
      </span>
    )
  const label = `${identity.catalogClass?.name ?? identity.catalogClassId}${identity.catalogSubtypeId ? ` / ${identity.catalogSubtype?.name ?? identity.catalogSubtypeId}` : ''}`
  return (
    <span className="block text-xs font-normal">
      {canBrowseCatalog ? (
        <Link className="underline" to="/catalog/classes">
          {label}
        </Link>
      ) : (
        <span>{label}</span>
      )}
      {identity.divisionCode && ` · Division ${identity.divisionCode}`}
    </span>
  )
}
